import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { PriceChangeFilterInput, PriceChangeFilterLookupItem } from "@/graphql/codegen/graphql"

interface ClassFilterChipsProps {
  selectedClass?: string
  onRemove: (key: keyof PriceChangeFilterInput, value?: string) => void
  productClasses?: PriceChangeFilterLookupItem[]
}

const ProductClassFilterChip: React.FC<ClassFilterChipsProps> = ({ selectedClass, onRemove, productClasses }) => {
  const className = useMemo(
    () => productClasses?.find((productClass) => productClass.id === selectedClass)?.label ?? "",
    [selectedClass, productClasses]
  )

  return (
    <FilterChip
      key='pricing.product-class-filter-chip'
      data-testid='pricing.product-class-filter-chip'
      label={`Product Class: ${className}`}
      onDelete={() => onRemove("productClassId", undefined)}
    />
  )
}

export default ProductClassFilterChip
